import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MobileTabBar from './MobileTabBar';
import Breadcrumb from './Breadcrumb';
import ScrollToTop from './ScrollToTop';
import { FeatureFlagDebugPanel } from './FeatureFlagDebugPanel';

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col safe-area-top safe-area-left safe-area-right">
      <Header />
      <Breadcrumb />
      <main className="flex-1 pb-20 md:pb-0 safe-area-bottom">
        <Outlet />
      </main>
      <Footer />
      <MobileTabBar />
      <ScrollToTop />
      <FeatureFlagDebugPanel />
    </div>
  );
};

export default Layout;